import React from "react";
import { OptionDropdown } from "@/components/ui/OptionDropdown";
import type { DropdownOption } from "@/components/ui/OptionDropdown";
import { IdeaStatus } from "../types";
import { IDEA_STATUS_CONFIG } from "../ideaStatusConfig";

interface IdeaStatusBadgeProps {
  status: IdeaStatus;
  onStatusChange?: (status: IdeaStatus) => void;
  disabled?: boolean;
  align?: "left" | "right";
}

const OPTIONS: DropdownOption<IdeaStatus>[] = Object.entries(
  IDEA_STATUS_CONFIG
).map(([value, cfg]) => ({
  value: value as IdeaStatus,
  label: cfg.label,
  bg: cfg.bg,
  text: cfg.text,
  dot: cfg.dot,
}));

export const IdeaStatusBadge: React.FC<IdeaStatusBadgeProps> = ({
  status,
  onStatusChange,
  disabled = false,
  align = "left",
}) => {
  return (
    <OptionDropdown
      value={status}
      options={OPTIONS}
      onChange={onStatusChange}
      disabled={disabled}
      align={align}
    />
  );
};
